"use client";

import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

interface LoadingTransitionProps {
  loading: boolean;
  children: React.ReactNode;
  className?: string;
  loadingText?: string;
}

export function LoadingTransition({
  loading,
  children,
  className,
  loadingText = "Loading...",
}: LoadingTransitionProps) {
  if (loading) {
    return (
      <div className={cn("flex flex-col items-center justify-center p-8", className)}>
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="mt-2 text-sm text-muted-foreground">{loadingText}</p>
      </div>
    );
  }

  return <>{children}</>;
}

interface InlineLoadingProps {
  loading: boolean;
  children: React.ReactNode;
  className?: string;
}

export function InlineLoading({ loading, children, className }: InlineLoadingProps) {
  return (
    <div className={cn("relative", className)}>
      {children}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center rounded-md bg-background/80 backdrop-blur-sm">
          <Loader2 className="h-6 w-6 animate-spin text-primary" />
        </div>
      )}
    </div>
  );
}
